import React from 'react'
import './Footer.modules.css';

function Footer() {
    return (
        <div className='container-fluid' id='footer'>
            <div>
                <div id='medias'>
                    <a href='https://www.instagram.com/s_anthos_h_m/'target='_blank'rel="noreferrer"><i className="fab fa-instagram links"></i></a>
                    <a href='https://github.com/SANTHOSH17-DOT/'target='_blank'rel="noreferrer"><i className="fab fa-github-square links"></i></a>
                    <a href='https://www.linkedin.com/in/santhosh-m-041689217/'target='_blank'rel="noreferrer"><i className="fab fa-linkedin-in links"></i></a>
                    <a href='mailto:paradise.parrot03@gmail.com'><i className="fas fa-envelope links"></i></a>
                </div>
            </div>
        </div>
    )
}

export default Footer
